
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderModel } from './Entities.GormCrm.Order';
import { OrderLineCommissionModel } from './Entities.GormCrm.OrderLineCommission';
import { ProductVariantModel } from './Entities.GormCrm.ProductVariant';
import { QuestionnaireQuestionReplyModel } from './Entities.GormCrm.QuestionnaireQuestionReply';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class OrderLineModel extends Model<OrderLineModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'orderLine.property.id', isHidden: true },
		{ name: 'orderId', type: 'guid', languageString: 'orderLine.property.orderId' },
		{ name: 'quantity', type: 'number', languageString: 'orderLine.property.quantity' },
		{ name: 'totalPrice', type: 'number', languageString: 'orderLine.property.totalPrice' },
		{ name: 'startupAmount', type: 'number', languageString: 'orderLine.property.startupAmount' },
		{ name: 'startupAmountExclFirstInvoice', type: 'number', languageString: 'orderLine.property.startupAmountExclFirstInvoice' },
		{ name: 'startupInstallments', type: 'number', languageString: 'orderLine.property.startupInstallments' },
		{ name: 'productVariantId', type: 'guid', languageString: 'orderLine.property.productVariantId' },
		{ name: 'parentLineId', type: 'guid', languageString: 'orderLine.property.parentLineId' },
		{ name: 'generateInvoicesBasedOnProductPlanId', type: 'guid', languageString: 'orderLine.property.generateInvoicesBasedOnProductPlanId' },
		{ name: 'paymentInterval', type: 'number', languageString: 'orderLine.property.paymentInterval' },
		{ name: 'numberOfInstallments', type: 'number', languageString: 'orderLine.property.numberOfInstallments' },
		{ name: 'discount', type: 'number', languageString: 'orderLine.property.discount' },
		{ name: 'inverseParentLine', type: 'OrderLineModel[]', languageString: 'orderLine.property.inverseParentLine', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'order', type: 'OrderModel', languageString: 'orderLine.property.order', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'orderLineCommission', type: 'OrderLineCommissionModel', languageString: 'orderLine.property.orderLineCommission', isHidden: true, isObject: true, new: () => { return new OrderLineCommissionModel }, properties: () => { return OrderLineCommissionModel.classProperties } },
		{ name: 'parentLine', type: 'OrderLineModel', languageString: 'orderLine.property.parentLine', isHidden: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'productVariant', type: 'ProductVariantModel', languageString: 'orderLine.property.productVariant', isHidden: true, isObject: true, new: () => { return new ProductVariantModel }, properties: () => { return ProductVariantModel.classProperties } },
		{ name: 'questionnaireQuestionReplies', type: 'QuestionnaireQuestionReplyModel[]', languageString: 'orderLine.property.questionnaireQuestionReplies', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionReplyModel }, properties: () => { return QuestionnaireQuestionReplyModel.classProperties } },
		{ name: 'changeLogPrimaryRelationEntityId', type: 'string', languageString: 'orderLine.property.changeLogPrimaryRelationEntityId' },
		{ name: 'changeLogPrimaryRelationEntityType', type: 'string', languageString: 'orderLine.property.changeLogPrimaryRelationEntityType' },
		{ name: 'childLines', type: 'OrderLineModel[]', languageString: 'orderLine.property.childLines', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'totalPriceWithDiscount', type: 'number', languageString: 'orderLine.property.totalPriceWithDiscount' },
		{ name: 'productPlans', type: 'ProductPlanModel[]', languageString: 'orderLine.property.productPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public orderId?: string;
	public quantity: number;
	public totalPrice: number;
	public startupAmount?: number;
	public startupAmountExclFirstInvoice?: number;
	public startupInstallments?: number;
	public productVariantId?: string;
	public parentLineId?: string;
	public generateInvoicesBasedOnProductPlanId?: string;
	public paymentInterval: number;
	public numberOfInstallments?: number;
	public discount?: number;
	public inverseParentLine: OrderLineModel[];
	public order?: OrderModel;
	public orderLineCommission?: OrderLineCommissionModel;
	public parentLine?: OrderLineModel;
	public productVariant?: ProductVariantModel;
	public questionnaireQuestionReplies: QuestionnaireQuestionReplyModel[];
	public changeLogPrimaryRelationEntityId: string;
	public changeLogPrimaryRelationEntityType: string;
	public childLines: OrderLineModel[];
	public totalPriceWithDiscount: number;
	public productPlans: ProductPlanModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.orderId = undefined;
		this.quantity = 0;
		this.totalPrice = 0;
		this.startupAmount = undefined;
		this.startupAmountExclFirstInvoice = undefined;
		this.startupInstallments = undefined;
		this.productVariantId = undefined;
		this.parentLineId = undefined;
		this.generateInvoicesBasedOnProductPlanId = undefined;
		this.paymentInterval = 0;
		this.numberOfInstallments = undefined;
		this.discount = undefined;
		this.inverseParentLine = [];
		this.order = undefined;
		this.orderLineCommission = undefined;
		this.parentLine = undefined;
		this.productVariant = undefined;
		this.questionnaireQuestionReplies = [];
		this.changeLogPrimaryRelationEntityId = '';
		this.changeLogPrimaryRelationEntityType = '';
		this.childLines = [];
		this.totalPriceWithDiscount = 0;
		this.productPlans = [];
		
	}
	getProperties(){
		return OrderLineModel.classProperties;
	}
}

